// extracted by mini-css-extract-plugin
export default {"samsungPayContainer":"styles__samsungPayContainer___Q_T5o","iconPadding":"styles__iconPadding___ukdRj"};